import { GetterTree } from 'vuex'

import { PaymentMethod } from '@/models'

import { orderByLocale } from '@/utils'

import { RootState } from '../state'
import { PaymentMethodState } from './state'

const getters: GetterTree<PaymentMethodState, RootState> = {
  /**
   * Returns a AllowedPaymentMethod by its id, or null if not found.
   *
   * @param id PaymentMethod id to be found.
   */
  allowedPaymentMethodById: (state) => (id: number): PaymentMethod | null => {
    return state.allowedPaymentMethods.elements.find((i) => i.id === id) || null
  },

  /**
   * Returns AllowedPaymentMethods ordered by name.
   */
  orderedAllowedPaymentMethods (state): PaymentMethod[] {
    return orderByLocale(state.allowedPaymentMethods.elements, 'name')
  },

  /**
   * Returns a PaymentMethod by its id, or null if not found.
   *
   * @param id PaymentMethod id to be found.
   */
  paymentMethodById: (state) => (id: number): PaymentMethod | null => {
    return state.allPaymentMethods.elements.find((i) => i.id === id) || null
  },

  /**
   * Returns PaymentMethods ordered by name.
   */
  orderedPaymentMethods (state): PaymentMethod[] {
    return orderByLocale(state.allPaymentMethods.elements, 'name')
  },

  /**
   * Returns unbided PaymentMethods
   */
  unbidedPaymentMethods (state): PaymentMethod[] {
    const allowed = state.allowedPaymentMethods.elements
    return state.allPaymentMethods.elements.filter((e) => !allowed.find(({ id }) => e.id === id))
  }
}

export default getters
